import http from '@/common/utils/http-common';
import Status from '@/types/Status.type';

type GetParams = {
  params: {
    sortKey: string;
  };
};
class StatusService {
  getAll(params?: GetParams) {
    return http.get('/statuses', params);
  }

  get(id: string) {
    return http.get(`/statuses/${id}`);
  }

  create(data: Status) {
    return http.post('/statuses', data);
  }

  update(data: Status, id: string) {
    return http.put(`/statuses/${id}`, data);
  }

  delete(id: number) {
    return http.delete(`/statuses/${id}`);
  }

  getQuick() {
    return http.get(`/statuses/quick`);
  }
}

export default new StatusService();
